var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 46,
    viewBox: "0 0 52 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6004 40.8C19.6004 43.451 17.4514 45.6 14.8004 45.6C12.1494 45.6 10.0004 43.451 10.0004 40.8C10.0004 38.1491 12.1494 36 14.8004 36C17.4514 36 19.6004 38.1491 19.6004 40.8Z",
    fill: "#9EA3AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0004 40.8C42.0004 43.451 39.8514 45.6 37.2004 45.6C34.5494 45.6 32.4004 43.451 32.4004 40.8C32.4004 38.1491 34.5494 36 37.2004 36C39.8514 36 42.0004 38.1491 42.0004 40.8Z",
    fill: "#9EA3AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60039 0.800049C1.83308 0.800049 0.400391 2.23274 0.400391 4.00005V36C0.400391 37.7674 1.83308 39.2001 3.60039 39.2001H6.96042C7.70165 35.5485 10.9301 32.8 14.8004 32.8C18.6707 32.8 21.8991 35.5485 22.6404 39.2001H26.0004C27.7677 39.2001 29.2004 37.7674 29.2004 36V4.00005C29.2004 2.23274 27.7677 0.800049 26.0004 0.800049H3.60039Z",
    fill: "#9EA3AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8004 10.4C37.0331 10.4 35.6004 11.8327 35.6004 13.6V32.9601C36.1174 32.8551 36.6524 32.8 37.2004 32.8C41.0707 32.8 44.2991 35.5485 45.0404 39.2001H48.4004C50.1677 39.2001 51.6004 37.7674 51.6004 36V20C51.6004 19.1514 51.2632 18.3374 50.6631 17.7373L44.2631 11.3373C43.663 10.7372 42.8491 10.4 42.0004 10.4H38.8004Z",
    fill: "#9EA3AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/Truck.d21d445b7919b5584f39fef3d9f308db.svg";
export { ForwardRef as ReactComponent };